import { Skeleton as e } from "../Primitives/Skeleton.mjs";
import { EmptyCell as t, TBody as n, TD as r, TR as i } from "./TableStyles.mjs";
import { useEffect as a, useLayoutEffect as o, useRef as s, useState as c } from "react";
import { Fragment as l, jsx as u, jsxs as d } from "react/jsx-runtime";
import { useVirtualizer as f, useWindowVirtualizer as p } from "@tanstack/react-virtual";
//#region src/components/Table/TableBody.tsx
var m = 45, h = 5, g = (e) => {
	let { getRoot: t, sentinelRef: n, enabled: r, onEndReached: i, isFetchingNextPage: o, isLoading: c } = e, l = s(i);
	l.current = i;
	let u = s({
		isFetchingNextPage: o,
		isLoading: c
	});
	u.current = {
		isFetchingNextPage: o,
		isLoading: c
	}, a(() => {
		if (!r) return;
		let e = n.current;
		if (!e) return;
		let i = new IntersectionObserver((e) => {
			e[0]?.isIntersecting && (u.current.isFetchingNextPage || u.current.isLoading || l.current?.());
		}, {
			root: t(),
			rootMargin: "0px 0px 200px 0px",
			threshold: 0
		});
		return i.observe(e), () => i.disconnect();
	}, [r, n]);
}, _ = ({ data: a, processedColumns: o, isLoading: s, isFetchingNextPage: c, emptyMessage: f, selectedRows: p, onRowClick: m, getRowKey: h, getRowStyle: g, renderCell: _, onEndReached: v, virtualItems: y, totalSize: b, scrollOffset: x, measureElement: S, sentinelRef: C, bodyRef: w }) => {
	let T = [
		,
		,
		,
		,
		,
	].fill(null), E = y.length > 0 ? (y[0]?.start ?? 0) - x : 0, D = y.length > 0 ? b - ((y[y.length - 1]?.end ?? 0) - x) : 0;
	return /* @__PURE__ */ d(n, {
		ref: w,
		children: [
			s && a.length === 0 ? T.map((t, n) => /* @__PURE__ */ u(i, {
				$clickable: !1,
				children: o.map((t, n) => /* @__PURE__ */ u(r, {
					className: t.className,
					$align: t.align ?? "left",
					$pinned: t.pinned,
					$offset: t._offset,
					children: t.id === "__selection__" || t.id === "__actions__" ? null : /* @__PURE__ */ u(e, { height: 20 })
				}, `skel-col-${n}`))
			}, `skel-row-${n}`)) : a.length === 0 ? /* @__PURE__ */ u(i, {
				$clickable: !1,
				children: /* @__PURE__ */ u(t, {
					colSpan: o.length,
					children: f
				})
			}) : /* @__PURE__ */ d(l, { children: [
				E > 0 && /* @__PURE__ */ u("tr", { children: /* @__PURE__ */ u("td", {
					style: {
						padding: 0,
						height: `${E}px`
					},
					colSpan: o.length
				}) }),
				y.map((e) => {
					let t = e.index, n = a[t], s = h(n, t), c = p.some((e) => e.id === n.id);
					return /* @__PURE__ */ u(i, {
						onClick: () => m?.(n),
						$clickable: !!m,
						$isSelected: c,
						"data-index": e.index,
						ref: S,
						style: g?.(n),
						children: o.map((e, t) => /* @__PURE__ */ u(r, {
							className: e.className,
							$align: e.align ?? "left",
							$pinned: e.pinned,
							$offset: e._offset,
							children: _(n, e)
						}, `${s}-${e.id || t}`))
					}, s);
				}),
				D > 0 && /* @__PURE__ */ u("tr", { children: /* @__PURE__ */ u("td", {
					style: {
						padding: 0,
						height: `${D}px`
					},
					colSpan: o.length
				}) })
			] }),
			v && a.length > 0 && /* @__PURE__ */ u("tr", {
				ref: C,
				"aria-hidden": "true",
				children: /* @__PURE__ */ u("td", {
					style: {
						padding: 0,
						height: "1px"
					},
					colSpan: o.length
				})
			}),
			c && a.length > 0 && /* @__PURE__ */ u(i, {
				$clickable: !1,
				children: /* @__PURE__ */ u(t, {
					colSpan: o.length,
					children: /* @__PURE__ */ u(e, {
						height: 20,
						width: 150,
						style: { margin: "0 auto" }
					})
				})
			})
		]
	});
}, v = ({ scrollElementRef: e, ...t }) => {
	let n = s(null), r = f({
		count: t.data.length,
		getScrollElement: () => e.current,
		estimateSize: () => m,
		overscan: h
	});
	return g({
		getRoot: () => e.current,
		sentinelRef: n,
		enabled: !!t.onEndReached && t.data.length > 0,
		onEndReached: t.onEndReached,
		isFetchingNextPage: t.isFetchingNextPage,
		isLoading: t.isLoading
	}), /* @__PURE__ */ u(_, {
		...t,
		virtualItems: r.getVirtualItems(),
		totalSize: r.getTotalSize(),
		scrollOffset: 0,
		measureElement: r.measureElement,
		sentinelRef: n
	});
}, y = (e) => {
	let t = s(null), n = s(null), [r, i] = c(0);
	o(() => {
		let e = () => {
			n.current && i(n.current.getBoundingClientRect().top + window.scrollY);
		};
		return e(), window.addEventListener("resize", e), () => window.removeEventListener("resize", e);
	}, [e.data.length === 0]);
	let a = p({
		count: e.data.length,
		estimateSize: () => m,
		overscan: h,
		scrollMargin: r
	});
	return g({
		getRoot: () => null,
		sentinelRef: t,
		enabled: !!e.onEndReached && e.data.length > 0,
		onEndReached: e.onEndReached,
		isFetchingNextPage: e.isFetchingNextPage,
		isLoading: e.isLoading
	}), /* @__PURE__ */ u(_, {
		...e,
		virtualItems: a.getVirtualItems(),
		totalSize: a.getTotalSize(),
		scrollOffset: r,
		measureElement: a.measureElement,
		sentinelRef: t,
		bodyRef: n
	});
};
//#endregion
export { v as ElementScrollBody, y as WindowScrollBody };
